export default {
    en: {
        id: 'diagram3b4-1',
        blocks: [
            {
                task: 'S = When the sun fails, humans will turn to the energy of the visible universe.',
                answer: 'If X happens, will do Y',
                title: "S = ",
                modelName: 's'
            },
            {
                task: 'C = When they exhaust that, the only remaining store of energy will be in black holes',
                answer: 'After Y, only Z left',
                title: "C = ",
                modelName: 'c'
            },
            {
                task: 'Q = Might they be able to harvest this energy and save civilization?',
                answer: 'Will Z work?',
                title: "Q = ",
                modelName: 'q'
            },
            {
                task: 'A = Yes, if they had a space elevator, but that defies the laws of physics',
                answer: 'Yes, if…',
                title: "A = ",
                modelName: 'a'
            }
        ],
        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
        correctAnswers: 4
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/exercise1.js